module.exports = __webpack_public_path__ + "img/jp.7f572f6b.svg";